import React, { Component } from 'react';
import { Grid } from 'react-flexr';
import Card from './card';

export default class CategoryCards extends Component {
  render() {
    return (
      <Grid>
        {/*
        <Section icon='usd' title='Kviklån' text='Sammenlign kviklån' link={encodeURI('/kviklån')} />
        <Section icon='piggy-bank' title='Forbrugslån' text='Sammenlign forbrugslån' link={encodeURI('/forbrugslån')} />
        */}
        <Card
          icon="piggy-bank"
          title="Lån"
          text="Sammenlign lån"
          link={encodeURI('/lån')}
        />
        <Card
          icon="user"
          title="A-kasse"
          text="Sammenlign a-kasser"
          link="/a-kasse"
        />
        <Card
          icon="cutlery"
          title="Måltidskasse"
          text="Sammenlign måltidskasser"
          link={encodeURI('/mealbox')}
        />
        <Card
          icon="hd-video"
          title="Streaming"
          text="Sammenlign streaming service"
          link={encodeURI('/streaming')}
        />
        <Card
          icon="tv"
          title="TV udbydere"
          text="Sammenlign TV udbydere"
          link="/tv-udbydere"
        />
        <Card
          icon="tasks"
          title="Webhotel"
          text="Sammenlign webhoteller"
          link={encodeURI('/webhotel')}
        />
        <Card
          icon="signal"
          title="VPN"
          text="Sammenlign VPN'er"
          link={encodeURI('/vpn')}
        />
        <Card
          icon="phone"
          title="Mobil"
          text="Sammenlign mobiltelefoni"
          link="/mobilabonnement"
        />
        <Card
          icon="phone"
          title="Taletidskort"
          text="Sammenlign taletidskort"
          link="/taletidskort"
        />
        <Card
          icon="globe"
          title="Bredbånd"
          text="Sammenlign bredbånd"
          link={encodeURI('/bredbånd')}
        />
        <Card
          icon="signal"
          title="Mobilt Bredbånd"
          text="Sammenlign mobilt bredbånd"
          link={encodeURI('/mobilt-bredbånd')}
        />
      </Grid>
    );
  }
}
